import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

export default class HcsPointAndClickHelper extends Component {
    constructor(props) {
        super(props);

        let self = this;

        this.state = {
            hideDelay: 9999999,
            hidden: false
        };

        document.body.addEventListener("click", _ => {
            if(self.props.visible) {
                self.setState({
                    tooltipVisible: false
                }, _ => {
                    self.hide();
                });

            }
        });

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    show() {
        if(!this.props.visible) {
            return;
        }

        this.setState({
            hideDelay: 9999999,
            hidden: false
        }, _ => {
            ReactTooltip.rebuild();
            ReactTooltip.show(this.tipReference);
        });

        
    }

    hide() {
        if(!this.props.visible || this.state.hidden) {
            return;
        }

        this.setState({
            hideDelay: 200,
            hidden: true
        }, _ => {
            ReactTooltip.rebuild();
            // Must do this to override open tooltip with long hide delay of 9999999.
            ReactTooltip.hide(this.tipReference);
            ReactTooltip.show(this.tipReference);
            ReactTooltip.hide(this.tipReference);
        });
        
    }

    render() {
        return this.props.visible ? (
            <React.Fragment>
                <a
                    ref={ref => this.tipReference = ref}
                    data-tip="hcs-point-and-click-helper"
                    data-delay-hide={this.state.hideDelay}
                    data-type="light"
                    data-class="hcs-point-and-click-helper-tooltip"
                ></a>
                <div className="hcs-point-and-click-helper-placeholder">
                    <div className="hcs-point-and-click-helper-content"></div>
                </div>
            </React.Fragment>) : null;
    }
}